"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VendorFulfillmentFormPanes;
(function (VendorFulfillmentFormPanes) {
    VendorFulfillmentFormPanes[VendorFulfillmentFormPanes["Transportation"] = 0] = "Transportation";
    VendorFulfillmentFormPanes[VendorFulfillmentFormPanes["Hotel"] = 1] = "Hotel";
})(VendorFulfillmentFormPanes || (VendorFulfillmentFormPanes = {}));
exports.default = VendorFulfillmentFormPanes;
